import { render } from "./TaxRegistrationForm.vue?vue&type=template&id=8a1a3eba&scoped=true"
import script from "./TaxRegistrationForm.vue?vue&type=script&lang=js"
export * from "./TaxRegistrationForm.vue?vue&type=script&lang=js"

import "./TaxRegistrationForm.vue?vue&type=style&index=0&id=8a1a3eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1a3eba"]])

export default __exports__